<template>
  <div class="filePreview" :class="{ isIosx: isIosx }">
    <van-sticky>
      <div class="filePreviewNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">{{ title }}</span>
      </div>
    </van-sticky>
    <div class="filePreviewContent">
      <iframe
        :src="url"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="auto"
      ></iframe>
    </div>
  </div>
</template>

<script scoped>
export default {
  data() {
    return {
      isIosx: false,
      url: "",
      title: "",
    };
  },
  mounted() {
    this.isIosx = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.url) {
      this.url = this.$route.query.url;
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
    }
  },
  methods: {
    prev() {
      localStorage.setItem("filePreview", "true");
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.filePreview {
  height: 100%;
}
.filePreviewNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.filePreviewNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.filePreviewNav .navTitle {
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.filePreviewContent {
  height: calc(100% - 71px);
}

.isIosx .filePreviewNav {
  padding-top: 44px;
}
.isIosx .filePreviewContent {
  height: calc(100% - 77px);
}
</style>